import { ISterilisationCycleType } from '@principle-theorem/principle-core/interfaces';
import { AtLeast } from '@principle-theorem/shared';

export class SterilisationCycleType {
  static init(
    overrides: AtLeast<ISterilisationCycleType, 'name'>
  ): ISterilisationCycleType {
    return {
      isTestType: false,
      description: '',
      deleted: false,
      ...overrides,
    };
  }
}
